const loading = new Map<string, Promise<void>>()

/**
 * Adds a `<script src>` to the document once and resolves when it has run — for a vendor SDK
 * that ships only from its own CDN. A failed load is forgotten, so the next call tries again.
 */
export function loadExternalScript(src: string): Promise<void> {
  const existing = loading.get(src)
  if (existing) return existing

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      loading.delete(src)
      script.remove()
      reject(new Error(`Could not load ${src}`))
    }
    document.head.appendChild(script)
  })

  loading.set(src, promise)
  return promise
}
